import auth from '@client/components/auth';
import { InfluencerId, toInfluencerId } from '../model/community.types';

export const resolveInfluencerId = (
  influencerId?: string,
): InfluencerId | null => {
  const raw: string | number | null | undefined =
    influencerId ?? auth.getUser()?.influencerId;
  if (raw === null || raw === undefined) return null;
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? toInfluencerId(id) : null;
};
